<script>
import {defineComponent} from 'vue'
import {randomNum} from "@/utils/utils";

export default defineComponent({
  name: "ClSlider",
  props: {
    /**
     * @description slider items
     * @type {array}
     * */
    items: {
      type: Array,
      default() {
        return [];
      }
    },

    /**
     * @description to handle autoplay
     * @type {boolean}
     * */
    autoplay: {
      type: Boolean,
      default: true,
    },

    /**
     * @description time to slide left as milliseconds (ms)
     * @type {Number, String}
     * */
    interval: {
      type: [Number, String],
      default: 2500
    },

    /**
     * @description time to slide left as milliseconds (ms)
     * @type {Number, String}
     * */
    hideArrows: {
      type: [Boolean],
      default: false
    },


    /**
     * @description config slider breakpoints
     * @type {Object}
     * */
    breakPoints: {
      type: Object,
      default: () => {
        return {
          xs: {
            itemToShow: 1,
            itemToSlide: 1
          },
          sm: {
            itemToShow: 2,
            itemToSlide: 1
          },
          md: {
            itemToShow: 3,
            itemToSlide: 1
          },
          lg: {
            itemToShow: 5,
            itemToSlide: 1
          },
          xl: {
            itemToShow: 5,
            itemToSlide: 1
          }
        }
      }
    }
  },
  data() {
    return {

      id: "sliderHorizontal" + Date.now() + this.randomId(),

      /**
       * @description interval id that browser returned
       * @type {number}
       * */
      sliderInterval: 0,

      /**
       * @description default item width
       * @type {number}
       * */
      column_width: 200,

      /**
       * @description slider scroll left position
       * @type {number}
       * */
      scrollLeft: 0,

      /**
       * @description current item
       * @type {number}
       * */
      activeItemIndex: 0,
    }
  },
  methods: {
    /**
     * @description start slider autoplay
     * @return {number}
     * */
    startSlider(){
      this.sliderInterval = setInterval(()=>{
        if(this.activeItemIndex < this.items.length){
          this.nextProf();
        }
      },this.interval)
      return this.sliderInterval
    },

    /**
     * @description stop slider autoplay
     * @return void
     * */
    stopSlider(){
      clearInterval(this.sliderInterval);
    },


    nextProf(stopAutoplay){
      if(stopAutoplay) this.stopSlider();
      if(this.activeItemIndex >= this.items.length - this.itemShowManagement.itemToShow + this.endItemCount) {
        this.stopSlider();
      }
      else {
        this.scrollLeft = this.scrollLeft -(this.column_width * this.itemShowManagement.itemToSlide);
        this.activeItemIndex += this.itemShowManagement.itemToSlide;
        document.getElementById(this.id).scrollLeft = this.scrollLeft || 0
      }
    },
    prevProf(){
      this.stopSlider();
      if(!this.activeItemIndex) return;
      else {
        this.scrollLeft = this.scrollLeft +(this.column_width * this.itemShowManagement.itemToSlide);
        this.activeItemIndex -= this.itemShowManagement.itemToSlide;
        document.getElementById(this.id).scrollLeft = this.scrollLeft || 0
      }

    },

    randomId(){
      return randomNum(0,100);
    }
  },
  computed: {
    itemShowManagement(){
      if(this.$vuetify.display.xs){
        return {
          itemWidth:`${100/this.breakPoints.xs.itemToShow}%`,
          itemToSlide: this.breakPoints.xs.itemToSlide,
          itemToShow: this.breakPoints.xs.itemToShow,
        }
      }
      else if(this.$vuetify.display.sm){
        return {
          itemWidth:`${100/this.breakPoints.sm.itemToShow}%`,
          itemToSlide: this.breakPoints.sm.itemToSlide,
          itemToShow: this.breakPoints.sm.itemToShow,
        }
      }
      else if(this.$vuetify.display.md){
        return {
          itemWidth:`${100/this.breakPoints.md.itemToShow}%`,
          itemToSlide: this.breakPoints.md.itemToSlide,
          itemToShow: this.breakPoints.md.itemToShow,
        }
      }else if(this.$vuetify.display.lg){
        return {
          itemWidth:`${100/this.breakPoints.lg.itemToShow}%`,
          itemToSlide: this.breakPoints.lg.itemToSlide,
          itemToShow: this.breakPoints.lg.itemToShow,
        }
      }
      else if(this.$vuetify.display.xlAndUp){
        return {
          itemWidth:`${100/this.breakPoints.xl.itemToShow}%`,
          itemToSlide: this.breakPoints.xl.itemToSlide,
          itemToShow: this.breakPoints.xl.itemToShow,
        }
      }
      else return '20%'
    },

    endItemCount(){
      return this.$slots['end-item'] ? 1 : 0;
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs['slider-item'] && this.$refs['slider-item'].length > 0) {
        this.column_width = this.$refs['slider-item'][0].clientWidth;
        if (this.autoplay) this.startSlider();
      } else {
        console.warn("No slider items found, retrying...");
        setTimeout(() => {
          if (this.$refs['slider-item'] && this.$refs['slider-item'].length > 0) {
            this.column_width = this.$refs['slider-item'][0].clientWidth;
            if (this.autoplay) this.startSlider();
          }
        }, 500);
      }
    }, 500);
  },
  beforeUnmount() {
    this.stopSlider();
  }
})
</script>

<template>
  <div
      v-if="items"
      class="d-flex flex-row align-center"
  >
    <!--Start next btn  -------------------------------------------------------------->
    <div v-if="!hideArrows" class="pl-3">
      <i class="icon-angle-right slider-prev" @click="prevProf"></i>
    </div>
    <!--End next btn    -------------------------------------------------------------->

    <!--Start items     -------------------------------------------------------------->
    <v-row
        :id="id"
        ref="sliderHorizontal"
        class="mx-auto d-flex flex-row flex-nowrap py-3 overflow-scroll w-100 sliderHorizontal"
    >
      <div ref="slider-item" v-for="item in items" :key="'slider-' + item.id" class="slider-item" :style="{'width': itemShowManagement.itemWidth}" >
        <slot name="item" :item="item" />
      </div>
      <div v-if="$slots['end-item']"  key="'slider-end'" class="slider-item" :style="{'width': itemShowManagement.itemWidth}" >
        <slot name="end-item" />
      </div>
    </v-row>
    <!--End items       -------------------------------------------------------------->

    <!--Start prev btn  -------------------------------------------------------------->
    <div v-if="!hideArrows" class="pr-3" >
      <i class="icon-angle-left slider-next" @click="nextProf(true)"></i>
    </div>
    <!--End prev btn    -------------------------------------------------------------->
  </div>
</template>

<style scoped lang="scss">
.sliderHorizontal * {
  letter-spacing: 0 !important;
}

.sliderHorizontal::-webkit-scrollbar {
  width: 0 !important;
}
.sliderHorizontal {
  position: relative;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  overflow: scroll;
  width: auto;
}
.sliderHorizontal {
  .slider-next, .slider-prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .slider-next {
    left: 0;
  }

  .slider-prev {
    right: 0;
  }
}

.sliderHorizontal {
  .slider-item {
    flex-shrink: 0;
    margin: 0;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px
  }
}

.slider-next:before, .slider-prev:before {
  cursor: pointer;
  color: #989898;
  opacity: 1;
  font-size: 34px;
}
.cl-top-students-wrapper{
  .slider-next:before, .slider-prev:before {
    font-size: 45px;
    color: #ffffff;
  }
}

.img-blur{
  filter: blur(1.5rem);
}
</style>
